export const dlnShellsLogo = require("./dln_shells.png");
